import { ColumnType } from 'antd/es/table';
import axios from 'axios';

export interface ImportConfig {
  moduleName: string; // 默认使用moduleName
  title: string;
  templateFileName: string;
  columns: ColumnType<unknown>[];
  templateExcelName?: string; // 模板的真实名称，存在即不使用moduleName
  columnsModuleName?: string; // 真实表格列配置，存在即不适用moduleName
}

export interface StepProps extends ImportConfig {
  excelId?: ID;
}

const eduUserConfing: ImportConfig = {
  moduleName: 'edu',
  title: '教研室人员',
  templateFileName: '教研人员账号新增导入模板',
  columns: []
};

const teacherUserConfig: ImportConfig = {
  moduleName: 'teacher',
  title: '教师',
  templateFileName: '教师账号新增导入模板',
  columns: []
};

const classConfig: ImportConfig = {
  moduleName: 'class',
  title: '班级',
  templateFileName: '学校班级新增导入模板',
  columns: []
};

const studentConfig: ImportConfig = {
  moduleName: 'student',
  title: '学生',
  templateFileName: '学生名单新增导入模板',
  columns: []
};

const totalScoreConfig: ImportConfig = {
  moduleName: 'totalscore',
  title: '成绩',
  templateFileName: '成绩导入模板',
  columns: []
};

const partScoreConfig: ImportConfig = {
  moduleName: 'partscore',
  title: '成绩',
  templateFileName: '成绩导入模板',
  columns: []
};

// 英语口语
const englishSpokenConfig: ImportConfig = {
  moduleName: 'partscore',
  title: '成绩',
  templateFileName: '成绩导入模板',
  columns: [],
  templateExcelName: 'englishspoken',
  columnsModuleName: 'englishspoken'
};


// 配置 这里是给导入历史详情使用的
export const moduleNameExcelTypeRecord: Record<string, string> = {
  'edu': 'edu',
  'teacher': 'teacher',
  'school_class': 'class',
  'score': 'partscore',
  'student': 'student',
  'english_oral_score': 'englishspoken'
};

//  配置 依据模块获取页面配置
export const importConfigMap = new Map<string, ImportConfig>([
  ['edu', eduUserConfing],
  ['teacher', teacherUserConfig],
  ['class', classConfig],
  ['student', studentConfig],
  ['partscore', partScoreConfig],
  ['totalscore', totalScoreConfig],
  ['englishspoken', englishSpokenConfig]
]);

// 配置 历史导入记录依照模块来划分
export interface ImportModule {
  module: string;
  name: string;
}
export const importHistoryModuleMap = new Map<string, ImportModule>([
  ['edu', { module: 'edu', name: '教育局人员' }],
  ['teacher', { module: 'teacher', name: '教师' }],
  ['class', { module: 'school_class', name: '班级' }],
  ['student', { module: 'student', name: '学生' }],
  ['partscore', { module: 'score', name: '分数' }],
  ['totalscore', { module: 'score', name: '分数' }],
  ['englishspoken', { module: 'english_oral_score', name: '分数' }]
]);

export const downloadFileByBlob = (data: Blob, fileName: string) => {
  const blob = new Blob([data]);
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.download = fileName;
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(blobUrl);
};

export const downloadFileByUrl = (url: string, fileName: string) => {
  axios.get<Blob>(url, {
    responseType: 'blob'
  }).then(res => {
    downloadFileByBlob(res.data, fileName);
  });
};

export const downloadTemplate = (moduleName: string, fileName: string) => {
  const url = `/static/template/${moduleName}.xlsx`;
  const el = document.createElement('a');
  el.href = url;
  el.download = fileName + '.xlsx';
  el.click();
  document.removeChild(el);
};